/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contents } from '../../models/contents';

export interface ApiMasterContentGetContentBySubMenuIdGet$Params {
  id?: number;
}

export function apiMasterContentGetContentBySubMenuIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterContentGetContentBySubMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Contents>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContentGetContentBySubMenuIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Contents>;
    })
  );
}

apiMasterContentGetContentBySubMenuIdGet.PATH = '/api/Master/Content/GetContentBySubMenuId';
